import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Text, TextColor, ConditionalWrapper } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Link, Stack } from '@yonderland/andes-react';
import { useCountdownTimer } from '../../hooks/useCountdownTimer';
import AsNumeral from '../../vendors/asNumeral';
const MESSAGE_AMOUNT = '{AMOUNT}';
export const DeliveryConditionsBanner = ({ message, icon, link, cutoffTime, amountUntilFreeDelivery, }) => {
    const { currency } = useAemConfig();
    const { countdownMessage } = useCountdownTimer(cutoffTime, message);
    return (_jsx(ConditionalWrapper, { condition: Boolean(link), wrapper: children => (_jsx(Link, { href: link, variant: "tertiary", testId: "delivery-conditions-link", children: children })), children: _jsxs(Stack, { align: "center", children: [icon && _jsx(Icon, { name: icon, inline: true }), _jsx(Text, { color: TextColor.INHERIT, html: amountUntilFreeDelivery
                        ? countdownMessage === null || countdownMessage === void 0 ? void 0 : countdownMessage.replace(MESSAGE_AMOUNT, `${currency}${AsNumeral.formatAsCurrency(amountUntilFreeDelivery)}`)
                        : countdownMessage })] }) }));
};
